import { API_BASE_URL } from '../../../api/client';

/**
 * Absolute URL of the session recording. API URLs carry the access token as a
 * query parameter, because the <video> element streams with Range requests
 * and cannot send the Authorization header.
 */
export function streamingVideoUrl(session) {
  const videoUrl = session?.videoUrl || session?.video_url || session?.file_path;
  if (!videoUrl) return videoUrl;

  const absolute = videoUrl.startsWith('http') ? videoUrl : `${API_BASE_URL}${videoUrl}`;
  const token = absolute.includes('/api/') && localStorage.getItem('diploAccessKey');
  if (!token) return absolute;

  const separator = absolute.includes('?') ? '&' : '?';
  return `${absolute}${separator}token=${encodeURIComponent(token)}`;
}
